export { default } from './NewDetail';
